module.exports = __webpack_public_path__ + "img/logo.ee5ae5be.png";